import { ReactElement } from "react"

export function NotFound404Page(): ReactElement | null {
  return <div>Not Found: 404</div>
}
